import {get,post} from './axios';

let BaseUrl = process.env.NODE_ENV === "production" ? "/dashboard/" : "https://saas-test.megatechai.com/dashboard/"

export const getBase = (api, params) => get(`${BaseUrl}${api}`, params)
export const postBase = (api, params) => post(`${BaseUrl}${api}`, params)


export const postLogin = (api, params) => post(`${BaseUrl}users/${api}`, params)
export const getLogin = (api, params) => get(`${BaseUrl}users/${api}`, params)